(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ua = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports.ua = _exports.isWxwork = _exports.isIe = _exports.isIOS = _exports.isAndroid = _exports.inBrowser = void 0;
  var inBrowser = typeof window !== "undefined";
  _exports.inBrowser = inBrowser;
  var ua = inBrowser && navigator.userAgent.toLowerCase() || "";
  _exports.ua = ua;
  var isAndroid = ua && ua.indexOf("android") > 0;
  _exports.isAndroid = isAndroid;
  var isIOS = ua && /iphone|ipad|ipod|ios/.test(ua);
  _exports.isIOS = isIOS;
  var isIe = inBrowser && /MSIE|Trident/.test(window.navigator.userAgent);
  _exports.isIe = isIe;
  var isWxwork = /wxwork/i.test(ua);
  _exports.isWxwork = isWxwork;
});
//# sourceMappingURL=ua.js.map